import { Typography } from '@mui/material';

interface ErrorMessageProps {
  message?: string;
  defaultMessage?: string;
}

export const UploadErrorMessage = ({
  message,
  defaultMessage = '이미지를 업로드해주세요.',
}: ErrorMessageProps) => (
  <Typography
    variant="caption"
    sx={{
      color: 'error.main',
      mt: 1,
      display: 'block',
    }}
  >
    {String(message) ?? defaultMessage}
  </Typography>
);
